import { useEffect } from "react";
import { useLocation } from "react-router";

// Scrolls the element matching the current location hash into view, retrying
// across animation frames so the target can settle in once asynchronous data
// (brief, blueprint, etc.) has rendered. Bound to the hash + pathname so
// stage-tab switches that change ?stage=N re-trigger the scroll.
export function useScrollToHash(maxAttempts = 60): void {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const targetId = hash.startsWith("#") ? hash.slice(1) : hash;
    if (!targetId) return;

    let cancelled = false;
    let attempts = 0;

    function attempt() {
      if (cancelled) return;
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      attempts += 1;
      if (attempts < maxAttempts) {
        requestAnimationFrame(attempt);
      }
    }

    requestAnimationFrame(attempt);
    return () => {
      cancelled = true;
    };
  }, [hash, maxAttempts]);
}
